
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"129","height":"69"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"width":"129","height":"69","transform":"translate(477 392)","fill":"#fff","stroke":"#707070"}})])]),_c('g',{attrs:{"transform":"translate(-312.212 -284.363)"}},[_c('rect',{attrs:{"width":"48.091","height":"15.333","rx":"7.667","transform":"translate(352.667 338.03)","fill":"#f9487f"}}),_c('rect',{attrs:{"width":"57.848","height":"11.152","rx":"2.091","transform":"translate(348.485 284.364)","fill":"#e8ebf0"}}),_c('rect',{attrs:{"width":"117.788","height":"8.364","rx":"1.394","transform":"translate(317.818 303.879)","fill":"#e8ebf0"}}),_c('rect',{attrs:{"width":"80.152","height":"8.364","rx":"1.394","transform":"translate(336.636 317.818)","fill":"#e8ebf0"}})])])
          )
        }
      }
    